import React from 'react';
import { Crown } from 'lucide-react';

const FoundingMemberBadge = ({ size = 'medium' }) => {
  const sizeConfig = {
    small: { badge: 'fm-badge-sm', icon: 14, text: 'Founder' },
    medium: { badge: 'fm-badge-md', icon: 18, text: 'Founding Member' },
    large: { badge: 'fm-badge-lg', icon: 22, text: 'Founding Member' }
  };

  const config = sizeConfig[size];

  return (
    <div className={`fm-badge ${config.badge}`}>
      <div className="fm-badge-inner">
        <Crown size={config.icon} className="fm-crown" />
        <span className="fm-text">{config.text}</span>
      </div>
      <div className="fm-shine"></div>
    </div>
  );
};

export default FoundingMemberBadge;
